import { ChildForm } from "./ChildForm";

interface AddChildFormProps {
  onSuccess?: () => void;
}

export const AddChildForm = ({ onSuccess }: AddChildFormProps) => {
  return <ChildForm mode="add" onSuccess={onSuccess} />;
};